<template>
  <div class="event-search">
    <div>
    <div class="event" v-if="results.rows.length > 0">
      <div v-for="event in results.rows" class="event-entry" :key="event.id" itemscope itemtype="http://schema.org/Event">
        <meta itemprop="startDate" :content="event.dateFrom.replace('Z', event.timezone)">
        <meta itemprop="endDate" :content="event.dateTo.replace('Z', event.timezone)">
        <meta itemprop="location" :content="event.type === 'General Event' ? `${event.town} ${event.country}` : labels.onlineEvent">
        <meta itemprop="eventAttendanceMode" :content="event.type === 'General Event' ? 'https://schema.org/OfflineEventAttendanceMode' : 'https://schema.org/OnlineEventAttendanceMode'">
        <meta itemprop="image" :content="event.imageUrl">
        <meta itemprop="organizer" content="Clariant">
        <meta itemprop="performer" content="Clariant">
        <div class="event-coords desktop">
          <div class="event-dates" :class="{differentmonth: getMonth(event.dateFrom) !== getMonth(event.dateTo)}">
            <div class="event-months">
              <div class="event-month">{{getMonth(event.dateFrom)}}</div>
              <div class="event-date-separator">&nbsp;</div>
              <div class="event-month tomonth">{{getMonth(event.dateTo)}}</div>
            </div>
            <div class="event-days">
              <div class="event-day">{{getDay(event.dateFrom)}}</div>
              <div class="event-date-separator" v-if="!isSameDate(event.dateFrom,event.dateTo)">-</div>
              <div class="event-day" v-if="!isSameDate(event.dateFrom,event.dateTo)">{{getDay(event.dateTo)}}</div>
            </div>
            <div class="event-years">
              <div class="event-year">{{getYear(event.dateFrom)}}</div>
              <div class="event-date-separator">&nbsp;</div>
              <div class="event-year" v-if="getYear(event.dateFrom) !== getYear(event.dateTo)">{{getYear(event.dateTo)}}</div>
            </div>
          </div>
          <div class="download-ics" :title="labels.downloadIcs" @click="downloadIcs(event)"></div>
        </div>
        <div class="event-details" :class="{emptycontent:!event.hasText}">
            <meta itemprop="url" :content="event.url" />
            <div class="event-image" v-if="event.imageUrl" :style="{backgroundImage: 'url(' + event.imageUrl +')'}" @click="onEventClick(event)" role="img">
            </div>
            <div>
                <div class="event-town" v-if="event.type === 'General Event'">{{event.town}} {{event.country}}</div>
                <div class="event-town" v-if="event.type === 'Webinar'">{{labels.webinar}}</div>
                <div class="event-town" v-if="event.type === 'Bizzabo Event'">{{labels.bizzaboEventLocation}}</div>
                <div class="event-title" itemprop="name" @click="onEventClick(event)">{{event.title}}</div>
                <div class="event-coords tablet">
                  <div class="event-date">{{formatDate(event.dateFrom)}} {{isSameDate(event.dateFrom, event.dateTo) ? "": " - " + formatDate(event.dateTo)}}</div>  
                  <div class="download-ics" :title="labels.downloadIcs" @click="downloadIcs(event)"></div>
                </div>
                <div class="event-description" v-if="event.description || event.hasText"><span v-html="event.description" itemprop="description" @click="onEventClick(event)"></span>&nbsp;
                <a class="morelink" style="display: inline;" v-if="event.hasText" :title="event.title" :href="event.url">{{labels.more}}</a></div>
            </div>
        </div>
      </div>
      <Pager :total-items="results.totalRows" :current-items="results.rows.length" @click="onShowMore"></Pager>
    </div>
    <div class="no-items" v-if="results.rows.length == 0 && !isLoading">{{labels.noItemsFound}}</div>
    <div class="searchrefinersbox" style="display: block;" v-if="results.rows.length > 0 && results.facets.length > 0">
      <h2>{{labels.filterTitle}}</h2>
      <Facet v-for="facet in results.facets" :key="facet.name" :collapsed="isCollapsed(facet)" :label="facet.name" :facet-id="'events_'+facet.name" v-if="hiddenFacets.indexOf(facet.name) === -1">
          <FacetOption v-for="opt in facet.options" :label="opt.name" :value="facet.id+'='+opt.id" :count="opt.count" :key="opt.id" :on-change="onFacetOptionChecked" :checked="isFacetOptionChecked(facet.id+'='+opt.id)">
          </FacetOption>
      </Facet>
      <div class="result-facet past-events">
        <ul>
          <FacetOption :label="labels.pastEvents" :on-change="onTogglePastEvents" :checked="showPastEvents"></FacetOption>
        </ul>
      </div>
    </div>
    <div class="please-wait" v-if="isLoading">
      <img src="/images/pic_loading.gif" />
    </div>
  </div>
  <div class="result-facet past-events" v-if="results.rows.length == 0">
    <ul>
      <FacetOption :label="labels.pastEvents" :on-change="onTogglePastEvents" :checked="showPastEvents"></FacetOption>
    </ul>
  </div>
</div>
</template>

<script>
import 'es6-promise/auto'
import { Bus } from './services/bus.js'
import { Labels } from './services/labels.js'
import { Settings } from './services/settings.js'
import { Utils } from './services/utils.js'
import Facet from './ui/Facet.vue'
import FacetOption from './ui/FacetOption.vue'
import Pager from './ui/Pager.vue'
import axios from 'axios'
import { SessionState } from './services/session-state.js'

export default {
  name: 'EventSearch',
  components: {
    Facet,
    FacetOption,
    Pager
  },
  props: {
    resultCount: String
  },
  data () {
    return {
      labels: Labels,
      isLoading: false,
      currentQuery: "",
      results: {
        rows: [],
        facets: []
      },
      tags: "",
      showPastEvents: Settings.showPastEvents,
      collapsedFacets: Settings.events.collapsedFacets,
      selectedFacetOptions:[],
      isFirstQuery:true,
      hiddenFacets: Settings.hiddenFacets
    }
  },
  created() {
    Bus.$on("start-search", this.search)
  },
  beforeDestroy() {
    Bus.$off('start-search');
  },
  mounted() {
    var facetOpts = SessionState.get("events", "facets");
    if (facetOpts) {
      this.selectedFacetOptions = JSON.parse(facetOpts);
    }
    
    var pastevents = SessionState.get("events", "past_events");
    if (pastevents) {
      this.showPastEvents = (pastevents === "1");
    }
  },
  methods: {
    onEventClick(event) {
      if (!event) return;
      if (event.hasText) window.open(event.url, "_self");
    },
    isCollapsed(facet) {
      if (this.collapsedFacets.indexOf(facet.name) != -1) return true;
      else return false;
    },
    search (filters, fromWithin) {
      var oThis = this;
      oThis.currentQuery = filters.query;
      oThis.tags = filters.tags;
      console.log("Searching for events with " + filters.query)
      oThis.isLoading = true;
       if (!fromWithin && !this.isFirstQuery) {
        this.selectedFacetOptions = [];
        SessionState.set("events", "facets", null);
      }
      this.isFirstQuery = false;
      var url = Utils.constructNewQueryUrl("events", filters.query, this.selectedFacetOptions);
      if (this.showPastEvents) {
        url += "&pastEvents=1";
      }
      axios.get(url).then(function (response) {
        oThis.results = Utils.processSearchResults(response, oThis.results);
        if (oThis.tags.length > 0) {
          oThis.selectTagsInFacets();
        }
        oThis.$emit("input", oThis.results.totalRows);
        Utils.applyVisualUpdates(".event-search");
        oThis.isLoading = false;
        if (!fromWithin) {//we only report to analytics search queries, not results refining
          Utils.reportResultsToAnalytics("Events Search", filters.query, oThis.results.totalRows);
        }
      }).catch(function (err) {
          console.error("Error loading events: " + err.message);
          oThis.results = {rows: [], facets: []};
          oThis.$emit("input", oThis.results.totalRows);
          oThis.isLoading = false;
        });
      
    },
    onShowMore() {
      var oThis = this;
      console.log("Searching for more events with " + this.currentQuery)
      oThis.isLoading = true;
      var url = Utils.constructQueryUrl("events", this.currentQuery, oThis.results, oThis.selectedFacetOptions);
      if (this.showPastEvents) {
        url += "&pastEvents=1";
      }
      axios.get(url).then(function (response) {
        oThis.results = Utils.processSearchResults(response, oThis.results, true);
        Utils.applyVisualUpdates(".event-search");
        oThis.isLoading = false;
      }).catch(function (err) {
          console.error("Error loading events: " + err.message);
          oThis.results = {rows: [], facets: []};
          oThis.isLoading = false;
        });
    },
    onTogglePastEvents() {
      this.showPastEvents = !this.showPastEvents;
      this.search({query: this.currentQuery, tags:""}, true);
      SessionState.set("events", "past_events", this.showPastEvents ? "1" : "0"); 
    },
    onFacetOptionChecked(opt) {
      if (!opt) return;
      this.selectedFacetOptions = Utils.processFacetChecked(this.selectedFacetOptions, opt);
      this.search({query: this.currentQuery, tags:""}, true); 
      SessionState.set("events", "facets", JSON.stringify(this.selectedFacetOptions));
    },
    isFacetOptionChecked(val) {
      return (this.selectedFacetOptions.indexOf(val) != -1);
    },
    selectTagsInFacets() {
      if (!this.tags || this.tags.length == 0) return;
      if (this.results.facets.length == 0) return;
      var oThis = this;
      var bMustReload = false;
      var tags = oThis.tags.split(',');
      this.results.facets.forEach(function (facet) {
        facet.options.forEach(function (opt) {
          if (tags.indexOf(opt.id) != -1) {
            oThis.selectedFacetOptions.push(facet.id+"="+opt.id);
            var pos = oThis.collapsedFacets.indexOf(facet.name);
            if (pos != -1) oThis.collapsedFacets.splice(pos, 1);  //we expand the category automatically
            bMustReload = true;
          }
        });
      });
      if (bMustReload) {
        this.search({query: this.currentQuery, tags:""}, true);
      }
    },
    getDay(date) {
      //this is supposed to be an ISO date
      if (!date || date.length < 10) return "";
      return date.substr(8, 2);
    },
    getMonth(date) {
      if (!date || date.length < 10) return "";
      return Utils.getMonthName(parseInt(date.substr(5, 2)));
    },
    getYear(date) {
      if (!date || date.length < 10) return "";
      return date.substr(0, 4);
    },
    formatDate(date) {
      if (!date || date.length < 10) return "";
      return `${this.getMonth(date)} ${this.getDay(date)}, ${this.getYear(date)}`;
    },
    isSameDate(date1, date2) {
      if (!date1 || !date2 || date1.length < 10 || date2.length < 10) return false;
      return date1.substring(0, 10) === date2.substring(0, 10);
    },
    downloadIcs(event) {
      /*let ics = this.constructIcs(event);
      this.downloadFile(ics, event.title);*/
      window.open(`/api/event/downloadics?id=${event.id}`)
    },
    removePunctuation(date) {
      if (!date) return "";
      return date.replace(/[\.\-:Z]/gi, '');
    },
    getLocation (event) {
      if (event.town || event.country) {
        return `${event.town||""}${event.town?" " : ""}${event.country||""}`
      } else {
        return `${event.eventUrl||""}`;
      }
    },
    constructIcs(event) {
      if (!event) return null;
      if (event.dateFrom.indexOf("T00:00") !== -1 && event.dateTo.indexOf("T00:00") !== -1) { //this is a whole day event...we just add the date part
      return `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//Clariant.com//EN
BEGIN:VEVENT
UID:${event.id}
DTSTART;VALUE=DATE:${Utils.getIsoDate(new Date(event.dateFrom))}
DTEND;VALUE=DATE:${this.fixEndDate(event.dateTo)}
SUMMARY:${event.title}
LOCATION:${this.getLocation(event)}
DESCRIPTION:${event.description}
END:VEVENT
END:VCALENDAR
      `;
      } else {
        return `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//Clariant.com//EN
BEGIN:VEVENT
UID:${event.id}
DTSTART;TZID="${Utils.offsetToTimezoneId(event.timezone, event.dateFrom)}":${this.removePunctuation(event.dateFrom)}
DTEND;TZID="${Utils.offsetToTimezoneId(event.timezone, event.dateFrom)}":${this.removePunctuation(event.dateTo)}
SUMMARY:${event.title}
LOCATION:${this.getLocation(event)}
DESCRIPTION:${event.description}
END:VEVENT
END:VCALENDAR
      `;
      }
    },
    getTimezoneBlock(timezone, date) {
      return `BEGIN:VTIMEZONE
TZID:${Utils.offsetToTimezoneId(timezone, date)}
BEGIN:STANDARD
TZOFFSETFROM:${timezone.replace(":", "")}
TZOFFSETTO:${timezone.replace(":", "")}
END:STANDARD
END:VTIMEZONE`
    },
    fixEndDate(date) {
      if (!date) return "";
      var d = new Date(date);
      var nd = new Date(date);
      nd.setDate(d.getDate()+1);
      return Utils.getIsoDate(nd);
    },
    downloadFile(file, name) {
      if (!file) return;
      var filename = `${name || "Clariant Event"}.ics`;

      var blob = new Blob([file]);
      var link = document.createElement('a');
      if (window.navigator.msSaveOrOpenBlob) {
          link.onclick = function(e) {
              window.navigator.msSaveOrOpenBlob(blob, filename);
          }
      } else {
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
      }

      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.please-wait {
  display: flex;
  width:100%;
  justify-content: center;
}
.event-search > div {
  display: flex;
  flex-direction: row;
}

.event-search .event {
  width: calc(100% - 330px);
}

.event .event-entry {
    display: flex;
    margin-bottom: 20px;
    border-bottom:1px dotted #DDDDDD;
    padding-bottom: 10px;
}

.event .event-entry .event-date {
    font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 17px;
    color: #777;
    text-transform: none;
}

.event .event-entry .event-coords.desktop {
  width:150px;
  min-width: 150px;
  padding-top:3px;
  border-right:1px solid #ccc;
  display:flex;
  flex-direction:column;
}

.event .event-entry .event-coords.desktop > .event-dates {
  display: flex;
  flex-direction: column;
  margin: 0 20px 10px 0;
}

.event .event-entry .event-coords.desktop > .event-dates > .event-months {
  display: flex;
  flex-direction: row;
}

.event .event-entry .event-coords.desktop > .event-dates > .event-months > .event-month {
  font-family: "Gotham SSm A", Arial;
  font-size: 21px;
  font-weight: 300;
}

.event .event-entry .event-coords.desktop > .event-dates.differentmonth > .event-months > .event-month {
  width:50px;
}
.event .event-entry .event-coords.desktop > .event-dates:not(.differentmonth) > .event-months > .event-month.tomonth {
  display: none;
}

.event .event-entry .event-coords.desktop > .event-dates > .event-days {
  display: flex;
  flex-direction: row;
}

.event .event-entry .event-coords.desktop > .event-dates > .event-days > .event-day {
  font-family: "Gotham SSm A", Arial;
  font-size: 35px;
  font-weight: 100;
  padding: 10px 0;
  line-height: 40px;
}

.event .event-entry .event-coords.desktop > .event-dates.differentmonth > .event-days > .event-day {
  width:50px;
}

.event .event-entry .event-coords.desktop > .event-dates .event-date-separator {
  width: 30px;
  text-align: center;
}

.event .event-entry .event-coords.desktop > .event-dates > .event-days > .event-date-separator {
  font-family: "Gotham SSm A", Arial;
  font-size: 35px;
  font-weight: 100;
  padding: 10px 0;
  line-height: 40px;
}

.event .event-entry .event-coords.desktop > .event-dates > .event-years {
  display: flex;
  flex-direction: row;
}

.event .event-entry .event-coords.desktop > .event-dates > .event-years > .event-year {
  font-family: "Gotham SSm A", Arial;
  font-size: 21px;
  font-weight: 100;
}

.event .event-entry .event-coords.tablet {
  display: none;
  margin-bottom: 10px;
}

.event .event-entry .event-details {
    margin-left: 15px;
    color: #323232;
    display: flex;
    cursor: pointer;
}

.event .event-entry .event-details.emptycontent {
  cursor: default;
}

.event .event-entry .event-details div.event-town {
  font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
}

.event .event-entry .event-details div.event-title {
  font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
  font-weight: 500;
  font-size: 22px;
  margin: 5px 0 10px 0;
  word-wrap: normal;/*for IE*/
  word-wrap: break-word;
}

.event .event-entry .event-details .event-subtitle {
  font-family: "Gotham SSm A";
  font-size: 16px;
  text-transform: uppercase;
  font-weight: 500;
  word-wrap: normal;/*for IE*/
  word-wrap: break-word;
}

.event .event-entry .event-details .event-description {
  font-family: "Gotham Narrow", sans-serif;
  word-wrap: normal;/*for IE*/
  word-wrap: break-word;
  font-size: 15px;
}

.event .event-entry .event-details .event-image {
  width: 128px;
  height: 128px;
  border-radius: 5px;
  background-size: cover;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  min-width: 128px;
  margin-right: 15px;
}

.event .event-entry .morelink { 
	display: inline-block;
	padding-top: 1px;
	padding-left: 10px;
	font-family: 'Gotham SSm A', 'Gotham SSm B', sans-serif;
	font-weight: 500;
	font-size: 12px;
	line-height: inherit;
	text-transform: uppercase;
	background-image: url('../assets/bullet-arrow-blue.png');
	background-repeat: no-repeat;
	background-size: 6px 9px;
  background-position: 0px 4px;
  color:#2655FF;
  cursor: pointer;
}

.event-search .past-events {
  margin-top: 20px;
}

.searchrefinersbox {
  width: 300px;
  max-width: 300px;
  min-width: 300px;
  margin-left: 30px;
  margin-bottom: 40px;
}

.searchrefinersbox > H2 {
  padding-top: 2px;
  padding-bottom: 14px;
    font-family: 'Gotham SSm A', sans-serif;
    font-size: 20px;
    line-height: 24px;
    font-weight: 700;
    font-style: normal;
    text-transform: uppercase;
    border-bottom: 1px solid #e4e4e4;
}

.download-ics {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'%3E%3Cpath fill='%23777' d='M336 292v24c0 6.6-5.4 12-12 12h-76v76c0 6.6-5.4 12-12 12h-24c-6.6 0-12-5.4-12-12v-76h-76c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h76v-76c0-6.6 5.4-12 12-12h24c6.6 0 12 5.4 12 12v76h76c6.6 0 12 5.4 12 12zm112-180v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z'/%3E%3C/svg%3E");
}

.event-coords.desktop .download-ics {
  width:24px;
  height: 24px;
  background-size: 24px 23px;
  background-position: 50%;
  background-repeat: no-repeat;
  cursor: pointer;
  align-self:flex-end;
  margin-right:15px;
}

.event-coords.tablet .download-ics {
  width:16px;
  height: 16px;
  background-size: 16px 16px;
  background-position: 50%;
  background-repeat: no-repeat;
  cursor: pointer;
  margin-left: 15px;
}

@media all and (min-width: 781px) and (max-width: 960px) {

  .event-entry {
    flex-direction: column;
  }

  .event .event-entry .event-details {
  margin-left: 0;
}

.event .event-entry .event-coords.desktop {
  display: none;
}

.event .event-entry .event-coords.tablet {
   display: flex;
  flex-direction: row;
}
  
}


@media all and (max-width: 780px) {
.event-search > div{
  flex-wrap: wrap-reverse;
}

.event-search .event {
  width: 100%;
}

.searchrefinersbox {
  width: 100%;
  margin-left: 0;
  max-width: 100%;
  min-width: 100%;
}

.event .event-entry .event-details {
  margin-left: 0;
}

.event-entry {
    flex-direction: column;
  }

.event .event-entry .event-coords.desktop {
  display: none;
}

.event .event-entry .event-details .event-image {
  display: none;
}

.event .event-entry .event-coords.tablet {
  display: flex;
  flex-direction: row;
}

}
</style>
